"use client"

import { CLOUDINARY_CLOUD } from "@/lib/cloudinary";
import type React from "react";
import dynamic from "next/dynamic";
import { ThemeProvider } from "@/components/theme-provider";
// CLERK AUTHENTICATION - COMMENTED OUT FOR FUTURE USE
// import { AppSidebar } from "@/components/app-sidebar";
// import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
// import { SignedIn, SignedOut } from "@clerk/nextjs";
// import Image from "next/image";
// import { SignInClient } from "@/components/sign-in-client";
// import { AdminRouteGuard } from "@/components/admin-route-guard";
// import { usePathname } from "next/navigation";

// Defer loading of non-critical components to improve Speed Index
const Toaster = dynamic(() => import("@/components/ui/sonner").then(mod => ({ default: mod.Toaster })), {
  ssr: false,
});

export function LayoutClient({ children }: { children: React.ReactNode }) {
  // CLERK AUTHENTICATION - COMMENTED OUT FOR FUTURE USE
  // const pathname = usePathname();
  // const isPublicRoute = pathname === '/ranking-publico';

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      forcedTheme="light"
      enableSystem={false}
      disableTransitionOnChange
    >
      {/* Simple layout without authentication */}
      {children}
      <Toaster position="top-right" richColors />
      
      {/* CLERK AUTHENTICATION - COMMENTED OUT FOR FUTURE USE */}
      {/* {isPublicRoute ? (
        // Render public routes without authentication
        children
      ) : (
        <>
          <SignedOut>
            <div className="grid min-h-svh lg:grid-cols-2">
              <div className="bg-muted relative hidden lg:block">
                <Image
                  alt=""
                  src={`https://res.cloudinary.com/${CLOUDINARY_CLOUD}/image/upload/c_scale,w_2000/q_auto/f_auto/logos/person_signin_k2ln3r.jpg`}
                  className="absolute inset-0 h-full w-full object-cover"
                  height={1960}
                  width={2940}
                />
              </div>
              <div className="flex flex-col items-center justify-center gap-4 p-6 md:p-10 bg-[#193143]">
                <SignInClient />
              </div>
            </div>
          </SignedOut>

          <SignedIn>
            <AdminRouteGuard>
              <SidebarProvider>
                <AppSidebar />
                <SidebarInset className="overflow-hidden">{children}</SidebarInset>
              </SidebarProvider>
            </AdminRouteGuard>
            <Toaster position="top-right" richColors />
          </SignedIn>
        </>
      )} */}
    </ThemeProvider>
  );
}

